module.exports = __webpack_public_path__ + "img/J4.1d374b74.png";